import { render } from "./ChatLauncher.vue?vue&type=template&id=1dab6860&scoped=true"
import script from "./ChatLauncher.vue?vue&type=script&lang=js"
export * from "./ChatLauncher.vue?vue&type=script&lang=js"

import "./ChatLauncher.vue?vue&type=style&index=0&id=1dab6860&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1dab6860"]])

export default __exports__